import Router from "./routes";

function App() {
  return (
    <section>
      <Router />
    </section>
  );
}

export default App;
